import { Injectable } from '@angular/core';

export type PlatformType = 'pwa' | 'web' | 'mobile' | 'ios' | 'android';

@Injectable({
	providedIn: 'root',
})
export class PlatformDetectionService {
	private _isPWAMode = false;

	constructor() {
		this.setupReactivePWADetection();
	}

	/**
	 * Check if the current platform matches the specified type
	 * Similar to Ionic's platform.is() API for consistency
	 */
	is(platform: PlatformType): boolean {
		switch (platform) {
			case 'pwa':
				return this._isPWAMode;
			case 'web':
				// TODO: Implement web detection logic ML-3342
				return false;
			case 'mobile':
				// TODO: Implement mobile detection logic ML-3342
				return false;
			case 'ios':
				// TODO: Implement iOS detection logic ML-3342
				return false;
			case 'android':
				// TODO: Implement Android detection logic ML-3342
				return false;
			default:
				return false;
		}
	}

	/**
	 * Get the current PWA mode state (synchronous)
	 */
	get isPWAMode(): boolean {
		return this._isPWAMode;
	}

	/**
	 * Setup reactive PWA detection that updates immediately when switching
	 * from browser to PWA mode
	 */
	private setupReactivePWADetection(): void {
		// Initial detection
		this.updatePWAState();

		// Listen for display mode changes
		const mediaQuery = window.matchMedia('(display-mode: standalone)');
		mediaQuery.addEventListener('change', () => {
			this.updatePWAState();
		});
	}

	/**
	 * Update the PWA state by detecting if the app is running in standalone mode
	 *
	 * Uses two detection methods for cross-platform compatibility:
	 * - window.matchMedia('(display-mode: standalone)') - Standard method for modern browsers (Chrome, Edge, Firefox)
	 *   Works on: Desktop PWAs, Android Chrome PWAs, iOS Safari 14.5+ PWAs
	 * - navigator.standalone - Legacy iOS-specific fallback for older Safari versions
	 *   Works on: iOS Safari PWAs (all versions)
	 *
	 * Detects PWA mode on both mobile and desktop platforms when user launches
	 * the app from home screen icon or installed PWA rather than browser tab
	 */
	private updatePWAState(): void {
		this._isPWAMode =
			window.matchMedia('(display-mode: standalone)').matches ||
			(navigator as any).standalone === true;
	}
}
